import React from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import RoomUnderCleaningApp from './RoomUnderCleaningApp';
import CleaningReport from './CleaningReport';
import { setActiveTab } from '../state/actions-creators';

const MediumFont = styled.span`
  font-size: calc(1px + 2.5vmin);
`;

const RoomUnderCleaningTabs = () => {
  /* Renders the 2 tabs of the application */
  const activeTab = useSelector((state) => state.activeTab);
  const dispatch = useDispatch();

  return (
    <>
      <Tabs>
        <TabList>
          <Tab
            style={{
              backgroundColor: activeTab === 'app' ? '#d9d9d9' : null,
            }}
            onClick={() => dispatch(setActiveTab('app'))}
          >
            <MediumFont>Cleaning App</MediumFont>
          </Tab>
          <Tab
            style={{
              backgroundColor: activeTab === 'report' ? '#d9d9d9' : null,
            }}
            onClick={() => dispatch(setActiveTab('report'))}
          >
            <MediumFont>Report</MediumFont>
          </Tab>
        </TabList>

        <TabPanel>
          {/* <CleaningApp /> */}
          <RoomUnderCleaningApp/>
        </TabPanel>
        <TabPanel>
          <CleaningReport />
        </TabPanel>
      </Tabs>
    </>
  );
};

export default RoomUnderCleaningTabs;
